import cx from 'classnames';

import { useRouter } from 'hooks';

import styles from './FreeTrialPanel.Upgrade.module.scss';

const UpgradePanel = () => {
  const router = useRouter();

  const handleOnClickUpgrade = () => router.push('/pricing');

  return (
    <div className={styles.container}>
      <h3 className={styles.message}>You've exhausted your available streaming minutes, please upgrade your plan</h3>
      <button type="button" className={cx(styles.action, styles.upgrade)} onClick={handleOnClickUpgrade}>
        Upgrade
      </button>
    </div>
  );
};

export default UpgradePanel;
